import axios, { AxiosInstance } from "axios";

class NavbarAPI {
  private static instance: NavbarAPI;
  private client: AxiosInstance;
  private constructor() {
    const token = sessionStorage.getItem("jwt_access_token");
    const headers = { Authorization: `Bearer ${token}` };

    this.client = axios.create({
      baseURL: "https://api.thesimple.ink/site",
      // withCredentials: true,
      timeout: Infinity,
      headers: {
        "Content-Type": "application/json",
        ...headers,
      },
    });
  }

  static getInstance() {
    if (!this.instance) {
      this.instance = new NavbarAPI();
    }
    return this.instance;
  }

  fetch(siteId: string) {
    return this.client.get(`/${siteId}/navbar`);
  }

  create(siteId: string, data: any) {
    return this.client.post(`/${siteId}/navbar`, data);
  }

  update(siteId: string, data: any) {
    return this.client.put(`/${siteId}/navbar`, data);
  }

  remove(siteId: string) {
    return this.client.delete(`/${siteId}/navbar`);
  }

  createButton(siteId: string, data: any) {
    return this.client.post(`/${siteId}/navbar_button`, data);
  }

  createLink(siteId: string, data: any) {
    return this.client.post(`/${siteId}/navbar_link`, data);
  }

  updateButton(siteId: string, id: number, data: any) {
    return this.client.put(`/${siteId}/navbar_button/${id}`, data);
  }

  updateLink(siteId: string, id: number, data: any) {
    return this.client.put(`/${siteId}/navbar_link${id}`, data);
  }

  deleteButton(siteId: string, id: number) {
    return this.client.delete(`/${siteId}/navbar_button/${id}`);
  }

  deleteLink(siteId: string, id: number) {
    return this.client.delete(`/${siteId}/navbar_link/${id}`);
  }
}

export default NavbarAPI.getInstance();
// strict-origin-when-cross-origin
